/**
 * Created by zhengyf on 2017/12/05.
 */

; (function () {

    angular
        .module('app.core')
        .component('hoverNavMenuLeft', {
            template:'<div class="dssx-hover-nav-menu-left" ng-class="{\'mini\': vm.mode === \'mini\'}"><div class="hn-nav-menu-wrapper"><div class="hn-nav-title"><span>业务管理</span></div><ul class="hn-nav-menu-main-wrapper"><li class="hn-nav-menu-box" ng-repeat="mainItem in vm.c.mainMenus track by $index"><div class="hn-nav-menu-box-title"><a ng-href="{{mainItem.href}}" ng-bind="mainItem.title">我的快捷入口</a> <i class="iconfont icon-more"></i></div><div class="hn-nav-sub-box-wrapper" ng-class="{\'w540\': mainItem.subMenusRight.length}"><ul class="hn-nav-sub-box"><li class="hn-nav-sub-item" ng-repeat="subItem in mainItem.subMenusLeft" ng-class="{\'dotted-line\': subItem.showLine, \'spacing\': subItem.isAddMarginTop, \'right\': subItem.isRight}"><a ng-href="{{subItem.href}}" ng-bind="subItem.title" ng-class="{\'sub-title\': subItem.showLine}"></a></li></ul><ul class="hn-nav-sub-box"><li class="hn-nav-sub-item" ng-repeat="subItem in mainItem.subMenusRight" ng-class="{\'dotted-line\': subItem.showLine, \'spacing\': subItem.isAddMarginTop}"><a ng-href="{{subItem.href}}" ng-bind="subItem.title" ng-class="{\'sub-title\': subItem.showLine}"></a></li></ul></div></li></ul></div></div>',
            bindings: {
                mode: '<'
            },
            controllerAs: 'vm',
            controller: HoverNavMenuLeftCtrl
        })

    function HoverNavMenuLeftCtrl() {

        this.$onInit = onInit;
        this.$onChanges = bindingsOnChanges;

        var vm = this;

        var multiLangMarketProductManageBasePath = '/multi-lang-market.html#!/product-manage/'

        vm.c = {
            mainMenus: [
                {
                    title: '我的快捷入口',
                    href: 'javascript:;',
                    subMenusLeft: [],
                    subMenusRight: []
                },
                {
                    title: '订单管理',
                    href: 'javascript:;',
                    subMenusLeft: [
                        {
                            title: '所有订单',
                            href: 'javascript:;',
                            showLine: true
                        },
                        {
                            title: '所有订单',
                            href: 'javascript:;'
                        },
                        {
                            title: '评价订单',
                            href: 'javascript:;'
                        },
                        {
                            title: '订单回收站',
                            href: 'javascript:;'
                        },
                        {
                            title: '信用保障订单管理',
                            href: 'javascript:;',
                            isAddMarginTop: true,
                            showLine: true
                        },
                        {
                            title: '信用保障订单管理',
                            href: 'oms.html'
                        },
                        {
                            title: '信用保障评价管理',
                            href: 'javascript:;'
                        },
                        {
                            title: '待关联T/T外汇',
                            href: 'javascript:;'
                        },
                        {
                            title: '在线批发订单管理',
                            href: 'javascript:;',
                            isAddMarginTop: true,
                            showLine: true
                        },
                        {
                            title: '在线批发订单管理',
                            href: 'oms.html'
                        },
                        {
                            title: '在线批发评价管理',
                            href: 'javascript:;'
                        },
                        {
                            title: '在线批发纠纷管理',
                            href: 'javascript:;'
                        }
                    ],
                    subMenusRight: []
                },
                {
                    title: '信用保障服务',
                    href: 'javascript:;',
                    subMenusLeft: [
                        {
                            title: '信用保障服务管理中心',
                            href: 'javascript:;',
                            showLine: true
                        },
                        {
                            title: '信用保障服务管理中心',
                            href: 'javascript:;'
                        },
                        {
                            title: '交易管理',
                            href: 'javascript:;',
                            showLine: true,
                            isAddMarginTop: true
                        },
                        {
                            title: '起草信用保障订单',
                            href: 'draft-trusts.html'
                        },
                        {
                            title: '信用保障订单管理',
                            href: 'oms.html'
                        },
                        {
                            title: '资金管理',
                            href: 'oms.html',
                            isAddMarginTop: true,
                            showLine: true
                        },
                        {
                            title: '外汇关联',
                            href: 'javascript:;'
                        },
                        {
                            title: '交易对账单',
                            href: 'javascript:;'
                        },
                        {
                            title: '收款账号管理',
                            href: 'javascript:;'
                        },
                        {
                            title: '额度管理',
                            href: 'javascript:;',
                            isAddMarginTop: true,
                            showLine: true
                        },
                        {
                            title: '额度管理',
                            href: 'javascript:;'
                        }
                    ],
                    subMenusRight: [
                        {
                            title: '增值服务',
                            href: 'javascript:;',
                            showLine: true
                        },
                        {
                            title: '信用保障极速贷款',
                            href: 'javascript:;'
                        },
                        {
                            title: '尾款保障服务',
                            href: 'javascript:;'
                        }
                    ]
                },
                {
                    title: '超级信用证',
                    href: 'javascript:;',
                    subMenusLeft: [
                        {
                            title: '订单管理',
                            href: 'javascript:;',
                            showLine: true
                        },
                        {
                            title: '发起代理交单服务',
                            href: 'javascript:;'
                        },
                        {
                            title: '上传信用证草稿',
                            href: 'javascript:;'

                        },
                        {
                            title: '登记信用证正本',
                            href: 'javascript:;'
                        },
                        {
                            title: '融资管理',
                            href: 'javascript:;',
                            showLine: true,
                            isAddMarginTop: true
                        },
                        {
                            title: '打包贷款',
                            href: 'javascript:;'
                        },
                        {
                            title: '交单后贷款',
                            href: 'javascript:;'
                        }
                    ],
                    subMenusRight: []
                },
                {
                    title: '一达通\\金融\\物流',
                    href: 'javascript:;',
                    subMenusLeft: [
                        {
                            title: '一达通外贸综合服务',
                            href: 'javascript:;',
                            showLine: true
                        },
                        {
                            title: '通关\\外汇\\退税',
                            href: 'javascript:;'
                        },
                        {
                            title: '物流服务',
                            href: 'javascript:;',
                            showLine: true,
                            isAddMarginTop: true
                        },
                        {
                            title: '查询报价并安排发货',
                            href: 'logistics-query.html'
                        },
                        {
                            title: '管理物流订单',
                            href: 'javascript:;'
                        },
                        {
                            title: '我收到的委托单',
                            href: 'javascript:;'
                        },
                        {
                            title: '我的优惠券',
                            href: 'javascript:;'
                        },
                        {
                            title: '金融服务',
                            href: 'javascript:;',
                            showLine: true,
                            isAddMarginTop: true
                        },
                        {
                            title: '金融管家',
                            href: 'javascript:;'
                        },
                        {
                            title: '信用证管理',
                            href: 'javascript:;'
                        }
                    ],
                    subMenusRight: []
                },
                {
                    title: '商机管理中心（询盘）',
                    href: 'inquiry-manage.html',
                    subMenusLeft: [
                        {
                            title: '询盘',
                            href: 'inquiry-manage.html'
                        },
                        {
                            title: '客户',
                            href: 'client-manage.html'
                        },
                        {
                            title: '邮箱',
                            href: 'javascript:;'

                        },
                        {
                            title: '设置',
                            href: '/opportunity-management-set.html'
                        }
                    ],
                    subMenusRight: []
                },
                {
                    title: '采购直达',
                    href: 'javascript:;',
                    subMenusLeft: [
                        {
                            title: '供应',
                            href: 'javascript:;',
                            showLine: true
                        },
                        {
                            title: '企业信息验证',
                            href: 'javascript:;',
                        },
                        {
                            title: 'RFQ市场',
                            href: 'rfq-index.html'

                        },
                        {
                            title: '报价管理',
                            href: 'rfq/quotation-list.html'
                        },
                        {
                            title: '商机订阅',
                            href: 'business-communication.html#!/business-subscription'
                        },
                        {
                            title: '起草信用保障订单',
                            href: 'draft-trusts.html'
                        },
                        {
                            title: '样品单管理',
                            href: 'javascript:;'
                        },
                        {
                            title: '我的权益',
                            href: 'my-equity-detail.html'
                        },
                        {
                            title: '购买权益',
                            href: 'javascript:;'
                        },
                        {
                            title: '我的信保订单',
                            href: 'javascript:;'
                        },
                        {
                            title: '我的订单记录',
                            href: 'javascript:;'
                        },
                        {
                            title: '我的买家',
                            href: 'javascript:;'
                        }
                    ],
                    subMenusRight: [
                        {
                            title: '采购',
                            href: 'javascript:;',
                            showLine: true
                        },
                        {
                            title: '发布采购需求',
                            href: 'javascript:;'
                        },
                        {
                            title: '我的采购',
                            href: 'javascript:;'
                        },
                        {
                            title: '样品单管理',
                            href: 'javascript:;'
                        },
                        {
                            title: '我的供应商',
                            href: 'javascript:;'
                        },
                        {
                            title: '推荐的供应商',
                            href: 'javascript:;'
                        }
                    ]
                },
                {
                    title: '数据分析',
                    href: 'javascript:;',
                    subMenusLeft: [
                        {
                            title: '诊断中心',
                            href: 'javascript:;',
                            showLine: true
                        },
                        {
                            title: '诊断总览',
                            href: 'data-admin.html'
                        },
                        {
                            title: '知己',
                            href: 'javascript:;',
                            showLine: true,
                            isAddMarginTop: true
                        },
                        {
                            title: '我的效果',
                            href: 'data-admin.html#!/self-result'
                        },
                        {
                            title: '我的全球旺铺',
                            href: 'javascript:;'
                        },
                        {
                            title: '我的产品',
                            href: 'data-admin.html#!/self-product'
                        },
                        {
                            title: '我的词',
                            href: 'javascript:;'
                        },
                        {
                            title: '我的子账号',
                            href: 'javascript:;'
                        },
                        {
                            title: '知买家',
                            href: 'javascript:;',
                            showLine: true,
                            isAddMarginTop: true
                        },
                        {
                            title: '访客详情',
                            href: 'javascript:;'
                        },
                        {
                            title: '营销管理',
                            href: 'javascript:;'
                        }
                    ],
                    subMenusRight: [
                        {
                            title: '知行情',
                            href: 'javascript:;',
                            showLine: true
                        },
                        {
                            title: 'RFQ商机',
                            href: 'javascript:;'
                        },
                        {
                            title: '行业视角',
                            href: 'javascript:;'
                        },
                        {
                            title: '供货参谋',
                            href: 'javascript:;'
                        },
                        {
                            title: '专题',
                            href: 'javascript:;',
                            showLine: true,
                            isAddMarginTop: true
                        },
                        {
                            title: '信保指数',
                            href: 'javascript:;'
                        },
                        {
                            title: '信保指数',
                            href: 'javascript:;'
                        }
                    ]
                },
                {
                    title: '产品管理',
                    href: 'product-manage.html',
                    subMenusLeft: [
                        {
                            title: '发布产品',
                            href: 'javascript:;',
                            showLine: true
                        },
                        {
                            title: '发布产品',
                            href: 'product-post.html'
                        },
                        {
                            title: '管理产品',
                            href: 'javascript:;',
                            showLine: true,
                            isAddMarginTop: true
                        },
                        {
                            title: '管理产品',
                            href: 'product-manage.html'
                        },
                        {
                            title: '产品分组与排序',
                            href: 'manage-products-group.html'
                        },
                        {
                            title: '管理橱窗产品',
                            href: 'window-product-manage.html'
                        },
                        {
                            title: '管理认证产品',
                            href: 'javascript:;'
                        },
                        {
                            title: '管理优商专区',
                            href: 'javascript:;'
                        },
                        {
                            title: '关联一达通出口产品',
                            href: 'javascript:;'
                        },
                        {
                            title: '回收站',
                            href: 'javascript:;'
                        }
                    ],
                    subMenusRight: [
                        {
                            title: '工具中心',
                            href: 'javascript:;',
                            showLine: true
                        },
                        {
                            title: '管理图片银行',
                            href: 'photo-bank.html'
                        },
                        {
                            title: '管理视频银行',
                            href: 'javascript:;'
                        },
                        {
                            title: '管理智能编辑详情导航模版',
                            href: 'javascript:;'
                        },
                        {
                            title: '全文搜索工具',
                            href: 'javascript:;'
                        },
                        {
                            title: '管理标签',
                            href: 'javascript:;'
                        }, {
                            title: '管理行业商机',
                            href: 'javascript:;'
                        },
                        {
                            title: '搜索诊断',
                            href: 'javascript:;',
                            showLine: true,
                            isAddMarginTop: true
                        },
                        {
                            title: '搜索诊断首页',
                            href: 'javascript:;'
                        },
                        {
                            title: '供应商诊断优化',
                            href: 'javascript:;'
                        },
                        {
                            title: '关键词诊断优化',
                            href: 'javascript:;'
                        },
                        {
                            title: '产品诊断优化',
                            href: 'javascript:;'
                        },
                        {
                            title: '排名查询工具',
                            href: 'javascript:;'
                        },
                        {
                            title: '学习中心',
                            href: 'javascript:;'
                        }
                    ]
                },
                {
                    title: '营销中心',
                    // href: 'market-home.html',
                    href: 'marketing.html',
                    subMenusLeft: [
                        {
                            title: '营销中心概览',
                            // href: 'market-home.html'
                            href: 'marketing.html'
                        },
                        {
                            title: '外贸直通车',
                            // href: 'trade-train.html'
                            href: 'marketing.html'
                        },
                        {
                            title: '顶级展位',
                            href: 'javascript:;'
                        },
                        {
                            title: '橱窗',
                            href: 'window-product-manage.html'
                        }
                    ],
                    subMenusRight: []
                },
                {
                    title: '在线批发市场',
                    href: 'javascript:;',
                    subMenusLeft: [
                        {
                            title: '在线批发产品管理',
                            href: 'javascript:;',
                            showLine: true
                        },
                        {
                            title: '发布在线批发产品',
                            href: 'javascript:;'
                        },
                        {
                            title: '管理在线批发产品',
                            href: 'javascript:;'
                        },
                        {
                            title: '运费模板',
                            href: '/ship-templates.html'
                        },
                        {
                            title: '产品分组与排序',
                            href: 'manage-products-group.html'
                        },
                        {
                            title: '管理图片银行',
                            href: 'photo-bank.html'
                        },
                        {
                            title: '在线批发订单管理',
                            href: 'javascript:;',
                            showLine: true,
                            isAddMarginTop: true
                        },
                        {
                            title: '起草订单',
                            href: 'javascript:;'
                        },
                        {
                            title: '在线批发订单管理',
                            href: 'javascript:;'
                        },
                        {
                            title: '在线批发纠纷管理',
                            href: 'javascript:;'
                        },
                        {
                            title: '在线批发评价管理',
                            href: 'javascript:;'
                        },
                        {
                            title: '交易服务',
                            href: 'javascript:;',
                            showLine: true,
                            isAddMarginTop: true
                        },
                        {
                            title: '支付宝国际账户',
                            href: 'javascript:;'
                        }
                    ],
                    subMenusRight: [
                        {
                            title: '营销推广',
                            href: 'javascript:;',
                            showLine: true
                        },
                        {
                            title: '在线批发优惠券活动',
                            href: 'javascript:;'
                        },
                        {
                            title: '了解在线批发',
                            href: 'javascript:;'
                        },
                        {
                            title: '海外仓平台',
                            href: 'javascript:;',
                            showLine: true,
                            isAddMarginTop: true
                        },
                        {
                            title: '账号管理',
                            href: 'javascript:;'
                        },
                        {
                            title: '上传发货订单',
                            href: 'javascript:;'
                        },
                        {
                            title: '出库单管理',
                            href: 'javascript:;'
                        }
                    ]
                },
                {
                    title: '招商活动中心',
                    href: 'javascript:;',
                    subMenusLeft: [
                        {
                            title: '专场活动',
                            href: 'javascript:;'
                        },
                        {
                            title: '已报名活动',
                            href: 'javascript:;'
                        }
                        // {
                        //     title: '物流服务',
                        //     href: 'javascript:;',
                        //     showLine: true,
                        //     isAddMarginTop: true
                        // }
                    ],
                    subMenusRight: []
                },
                {
                    title: '建站管理',
                    href: 'javascript:;',
                    subMenusLeft: [
                        {
                            title: '企业网站',
                            href: 'javascript:;',
                            showLine: true
                        },
                        {
                            title: '管理全球旺铺',
                            href: 'winportIndx.html'
                        },
                        {
                            title: '域名管理',
                            href: 'javascript:;'
                        },
                        {
                            title: '公司介绍',
                            href: 'javascript:;',
                            showLine: true,
                            isAddMarginTop: true
                        },
                        {
                            title: '管理公司信息',
                            href: 'company-msg.html'
                        },
                        {
                            title: '贸易记录',
                            href: 'javascript:;'
                        },
                        {
                            title: '管理认证信息',
                            href: 'javascript:;',
                            showLine: true,
                            isAddMarginTop: true
                        },
                        {
                            title: 'A&V认证信息',
                            href: 'post-auth-info.html'
                        },
                        {
                            title: '管理能力评估报告',
                            href: 'javascript:;'
                        },
                        {
                            title: '全球E站',
                            href: 'javascript:;',
                            showLine: true,
                            isAddMarginTop: true
                        },
                        {
                            title: '管理全球E站',
                            href: 'javascript:;'
                        },
                        {
                            title: '域名管理',
                            href: 'javascript:;'
                        }
                    ],
                    subMenusRight: []
                },
                {
                    title: '多语言市场',
                    href: '/multi-lang-market.html#!/index',
                    subMenusLeft: [
                        {
                            title: '多语言市场首页',
                            href: '/multi-lang-market.html#!/index'
                        },
                        {
                            title: '西班牙语市场',
                            href: multiLangMarketProductManageBasePath + 'es'
                        },
                        {
                            title: '日语市场',
                            href: multiLangMarketProductManageBasePath + 'jp'
                        },
                        {
                            title: '葡萄牙语市场',
                            href: multiLangMarketProductManageBasePath + 'pt'
                        },
                        {
                            title: '法语市场',
                            href: multiLangMarketProductManageBasePath + 'fr'
                        },
                        {
                            title: '俄语市场',
                            href: multiLangMarketProductManageBasePath + 'ru'
                        },
                        {
                            title: '阿拉伯语市场',
                            href: multiLangMarketProductManageBasePath + 'ar'
                        },
                        {
                            title: '德语市场',
                            href: multiLangMarketProductManageBasePath + 'de'
                        },
                        {
                            title: '意大利语市场',
                            href: multiLangMarketProductManageBasePath + 'it'
                        },
                        {
                            title: '土耳其语市场',
                            href: multiLangMarketProductManageBasePath + 'tr'
                        },
                        {
                            title: '韩语市场',
                            href: multiLangMarketProductManageBasePath + 'ko'
                        },
                        {
                            title: '越南语市场',
                            href: multiLangMarketProductManageBasePath + 'vi'
                        },
                        {
                            title: '人工翻译',
                            href: 'javascript:;'
                        }
                    ],
                    subMenusRight: []
                },
                {
                    title: '我的外贸服务',
                    href: 'javascript:;',
                    subMenusLeft: [
                        {
                            title: '服务中心',
                            href: 'javascript:;',
                            showLine: true
                        },
                        {
                            title: '推荐服务',
                            href: 'javascript:;'
                        },
                        {
                            title: '我的服务订单',
                            href: 'javascript:;'
                        },
                        {
                            title: '发票中心',
                            href: 'javascript:;'
                        },
                        {
                            title: '产品代金券',
                            href: 'javascript:;'
                        },
                        {
                            title: '账户中心',
                            href: 'javascript:;',
                            showLine: true,
                            isAddMarginTop: true
                        },
                        {
                            title: '我的付费账户',
                            href: 'javascript:;'
                        },
                        {
                            title: '账单列表',
                            href: 'javascript:;'
                        },
                        {
                            title: '交易查询',
                            href: 'javascript:;'
                        },
                        {
                            title: '金融管家',
                            href: 'javascript:;'
                        },
                        {
                            title: '信用证管理',
                            href: 'javascript:;'
                        }
                    ],
                    subMenusRight: []
                }
            ]
        };

        function onInit() {
            console.log('[HoverNavMenuLeftCtrl init: ]');
            loadFavoriteMenu();
        }

        function bindingsOnChanges(changes) {

            if (changes.mode) {
                vm.mode = vm.mode || 'large';
            }
        }

        function loadFavoriteMenu() {

            var favoriteMenuConf = window.localStorage.getItem('dssx_favorite_menu') || [];
            var favoriteMenu;
            try {
                favoriteMenu = JSON.parse(favoriteMenuConf) || [];
            } catch (error) {
                console.log('[hover-nav-menu-left.js JSON.parse error: ]', error);
                favoriteMenu = [];
            }

            var list = [
                // {
                //     title: '添加/设置',
                //     href: 'javascript:;',
                //     isRight: true
                // }
            ];

            for (var i = 0; i < favoriteMenu.length; i++) {
                var item = {
                    title: favoriteMenu[i].zhCN,
                    href: favoriteMenu[i].url
                };
                list.push(item);
            }

            vm.c.mainMenus[0].subMenusLeft = list;
        }


    }

})();

